import { useEffect, useState } from "react";
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid } from "recharts";
import { api, usd } from "../lib/api";

export const Stat = ({ label, value, hint, positive = true, icon: Icon, testId }) => (
  <div className="stat" data-testid={testId}>
    <div className="stat-top"><span>{label}</span><Icon size={18} /></div>
    <strong>{value}</strong>
    <small className={positive ? "up" : "down"}>{hint}</small>
  </div>
);

export const Periods = ({ value, onChange, prefix }) => (
  <div className="periods">
    {["daily", "weekly", "monthly"].map((p) => (
      <button key={p} className={value === p ? "period active" : "period"} onClick={() => onChange(p)} data-testid={`${prefix}-${p}`}>
        {{ daily: "Harian", weekly: "Mingguan", monthly: "Bulanan" }[p]}
      </button>
    ))}
  </div>
);

export const ProfitChart = ({ data, dataKey = "cumulative", tall, color = "#27d69b" }) => (
  <div className={tall ? "chart tall" : "chart"}>
    <ResponsiveContainer width="100%" height="100%">
      <AreaChart data={data}>
        <defs>
          <linearGradient id={`g-${dataKey}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor={color} stopOpacity={0.3} />
            <stop offset="100%" stopColor={color} stopOpacity={0} />
          </linearGradient>
        </defs>
        <CartesianGrid stroke="#1c2330" vertical={false} />
        <XAxis dataKey="name" interval="preserveStartEnd" padding={{ left: 10, right: 10 }} axisLine={false} tickLine={false} tick={{ fill: "#6d788b", fontSize: 11 }} tickFormatter={(v) => v.slice(5)} />
        <YAxis axisLine={false} tickLine={false} tick={{ fill: "#6d788b", fontSize: 11 }} width={tall ? 60 : 0} hide={!tall} />
        <Tooltip formatter={(v) => usd(v)} contentStyle={{ background: "#151b25", border: "1px solid #273244", borderRadius: 0 }} />
        <Area type="monotone" dataKey={dataKey} stroke={color} strokeWidth={2.5} fill={`url(#g-${dataKey})`} />
      </AreaChart>
    </ResponsiveContainer>
  </div>
);

export const StatusPill = ({ status, testId }) => {
  const map = { connected: ["ok", "Tersinkron"], approved: ["ok", "Disetujui"], provisioning: ["warn", "Menghubungkan"],
    pending_config: ["warn", "Menunggu konfigurasi"], pending: ["warn", "Menunggu verifikasi"], due: ["warn", "Belum dibayar"],
    error: ["bad", "Error"], invalid: ["bad", "Kredensial ditolak"], rejected: ["bad", "Ditolak"], paid: ["ok", "Dibayar"], installed: ["ok", "EA terpasang"], waiting: ["warn", "Menunggu pemasangan"], problem: ["bad", "Kendala pemasangan"], none: ["mute", "Tidak ada tagihan"] };
  const [tone, label] = map[status] || ["mute", status];
  return <span className={`pill ${tone}`} data-testid={testId}>{label}</span>;
};

export const Modal = ({ onClose, children, wide, testId }) => (
  <div className="modal-backdrop" onClick={onClose}>
    <div className={wide ? "modal wide" : "modal"} onClick={(e) => e.stopPropagation()} data-testid={testId}>
      <button type="button" className="icon-btn modal-close" onClick={onClose} data-testid={`${testId}-close`}>✕</button>
      {children}
    </div>
  </div>
);

export const useBlobUrl = (path) => {
  const [url, setUrl] = useState(null);
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!path) { setUrl(null); setFailed(false); return undefined; }
    let current;
    setUrl(null);
    setFailed(false);
    api.get(path, { responseType: "blob" }).then((r) => { current = URL.createObjectURL(r.data); setUrl(current); }).catch(() => setFailed(true));
    return () => current && URL.revokeObjectURL(current);
  }, [path]);
  return { url, failed };
};

export const Empty = ({ icon: Icon, title, text, testId }) => (
  <div className="empty" data-testid={testId}><Icon size={26} /><b>{title}</b><p className="muted">{text}</p></div>
);
